import React from 'react';
import { getValueTypeControl } from '../../../constants/violationConstants';

/**
 * MetricInputFactory: контрол threshold выбирается по value_type из каталога.
 * Никаких зашитых бизнес-списков значений здесь нет — если catalog не прислал
 * варианты для enum, это backend/API gap, о котором мы честно пишем в UI.
 */

const readEnumOptions = (metricItem) => {
  const candidates = [
    metricItem?.enum_values,
    metricItem?.values,
    metricItem?.options,
    metricItem?.allowed_values,
  ];
  const found = candidates.find((candidate) => Array.isArray(candidate) && candidate.length > 0);
  return found ?? [];
};

export const coerceThreshold = (rawValue, valueType) => {
  const control = getValueTypeControl(valueType);
  if (control === 'boolean') return rawValue === 'true';
  if (control === 'integer') return Number(rawValue);
  if (control === 'number') return Number(rawValue);
  return rawValue;
};

const MetricThresholdInput = ({ metricItem, value, onChange, error }) => {
  const control = getValueTypeControl(metricItem?.value_type);
  const unitHint = metricItem?.unit ? `Значение в единицах «${metricItem.unit}».` : '';

  if (control === 'boolean') {
    return (
      <div className="vio-field">
        <label className="vio-field-label" htmlFor="vio-threshold">Значение</label>
        <select id="vio-threshold" value={value} onChange={(event) => onChange(event.target.value)}>
          <option value="">— выберите —</option>
          <option value="true">Да</option>
          <option value="false">Нет</option>
        </select>
        {error && <p className="vio-field-error">{error}</p>}
      </div>
    );
  }

  if (control === 'enum') {
    const options = readEnumOptions(metricItem);

    if (options.length === 0) {
      return (
        <div className="vio-field">
          <label className="vio-field-label" htmlFor="vio-threshold">Значение</label>
          <select id="vio-threshold" value="" disabled>
            <option value="">Варианты недоступны</option>
          </select>
          <p className="vio-field-hint vio-field-hint--warning">
            Для этого параметра пока нет списка допустимых значений, поэтому задать его нельзя.
          </p>
        </div>
      );
    }

    return (
      <div className="vio-field">
        <label className="vio-field-label" htmlFor="vio-threshold">Значение</label>
        <select id="vio-threshold" value={value} onChange={(event) => onChange(event.target.value)}>
          <option value="">— выберите —</option>
          {options.map((option) => {
            const optionValue = typeof option === 'object' ? option.value : option;
            const optionLabel = typeof option === 'object' ? option.label ?? option.value : option;
            return <option key={String(optionValue)} value={String(optionValue)}>{String(optionLabel)}</option>;
          })}
        </select>
        {error && <p className="vio-field-error">{error}</p>}
      </div>
    );
  }

  const isInteger = control === 'integer';
  const isNumber = control === 'number';

  return (
    <div className="vio-field">
      <label className="vio-field-label" htmlFor="vio-threshold">Значение</label>
      <input
        id="vio-threshold"
        type={isInteger || isNumber ? 'number' : 'text'}
        step={isInteger ? '1' : isNumber ? 'any' : undefined}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {metricItem && unitHint && <p className="vio-field-hint">{unitHint}</p>}
      {error && <p className="vio-field-error">{error}</p>}
    </div>
  );
};

export default MetricThresholdInput;
